import angular from 'angular';

import notes from './notes/notes.directive';
import courseHeader from './courseHeader/courseHeader.directive';
import paper from './paper/paper.directive';
import plainText from './plainText/plainText.directive';
import diagramComplete from './diagramComplete/diagramComplete.directive';
import unitFinish from './unitFinish/unitFinish.component';
import highliteWordDirective from './highliteWord/highliteWord.directive';
import courseVideo from './courseVideo/courseVideo.component';

const blocks = angular.module('minto.blocks', []);

blocks.directive('notes', notes);
blocks.directive('courseHeader', ['authService', '$state', courseHeader]);
blocks.directive('paper', paper);
blocks.directive('plainText', plainText);
blocks.directive('diagramComplete', diagramComplete);
blocks.component('unitFinish', unitFinish);
blocks.component('courseVideo', courseVideo);
blocks.directive('highliteWord', highliteWordDirective);

export default blocks;



// WEBPACK FOOTER //
// ./client/app/blocks/blocks.module.js